module.exports = __webpack_public_path__ + "static/img/Band_nato_red.4de7e5a.jpg";